import { Link } from "react-router-dom";
export interface PublicTip {
	id: string;
	seatKey: string;
	sectionCode: string;
	rowLabel: string;
	seatNumber: number;
	note: string;
	tags: string[];
	observedMonth: string;
	source: string;
	verification: string;
	edited: boolean;
	photoUrl: string | null;
	photoStatus?: string;
	photoNote?: string;
}
export function TipList({ tips }: { tips: PublicTip[] }) {
	return (
		<div className="tip-list">
			{tips.length ? (
				tips.map((tip) => (
					<article className="tip-item stack" key={tip.id}>
						<Link to={`/seat/${encodeURIComponent(tip.seatKey)}`}>
							<strong>
								{tip.sectionCode} {tip.rowLabel}열 {tip.seatNumber}번
							</strong>
						</Link>
						<p className="micro">
							{tip.source === "anonymous"
								? "로그인 없이 남긴 한 줄"
								: tip.verification === "purchase"
									? "구매 인증"
									: "앉아본 기록"}{" "}
							· {tip.observedMonth}
							{tip.edited ? " · 고침" : ""}
						</p>
						{tip.photoUrl ? (
							<img
								src={tip.photoUrl}
								alt="앉아본 자리에서 직접 찍은 빈 무대"
								loading="lazy"
							/>
						) : null}
						<p>{tip.note}</p>
						<div className="inline">
							{tip.tags.map((tag) => (
								<span className="tip-tag" key={tag}>
									{tag}
								</span>
							))}
						</div>
						<Link to={`/report/${tip.id}`}>신고하기</Link>
					</article>
				))
			) : (
				<p>
					아직 앉아본 한 줄이 없어요. 공식 위치를 먼저 확인하고, 다녀왔다면 한
					줄을 남겨 주세요.
				</p>
			)}
		</div>
	);
}
